{
  "ascending": "rastući",
  "ascendingSort": "razvrstano po stupcima {columnName} rastućem redoslijedom",
  "collapse": "Sažmi",
  "columnSize": "{value} piksela",
  "descending": "padajući",
  "descendingSort": "razvrstano po stupcima {columnName} padajućim redoslijedom",
  "expand": "Proširi",
  "resizerDescription": "Pritisnite Enter da biste započeli promenu veličine",
  "select": "Odaberite",
  "selectAll": "Odaberite sve",
  "sortable": "stupac koji se može razvrstati"
}
